import { EntityReference, EntityReferenceSchema, EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity, Currency, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { CurrencyConversionProviderType } from './currency-conversion.provider-type.enum';
import { QuoteStatus } from './quote.status.enum';

export const QuoteSchema = WithBaseEntitySchema(
    z.object({
        rate: z.number(),
        marketRate: z.number(),
        providerId: z.string().optional(),
        from: EnumSchema(Currency),
        to: EnumSchema(Currency),
        amount: z.number(),
        convertedAmount: z.number(),
        status: EnumSchema(QuoteStatus),
        providerType: EnumSchema(CurrencyConversionProviderType),
        entities: z.array(EntityReferenceSchema).optional(),
        feeDefinition: z.string(),
    }),
).strict();

export class Quote extends FromSchema(QuoteSchema) implements BaseEntity {
    id: string;
    rate: number;
    marketRate: number;
    providerId?: string;
    feeDefinition: string;
    from: Currency;
    to: Currency;
    amount: number;
    convertedAmount: number;
    status: QuoteStatus;
    providerType: CurrencyConversionProviderType;
    entities?: EntityReference[];
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
